
/*
    Style a div as a checkbox using a font-awesome svg so that it can be customized
*/

import React from "react";

/*
PROPS:
    - name
    - checked
    - label
    - onChange()
*/

const StyledCheckbox = (props) => {

    return (
        <div style={{
            display: "inline-block"
        }}>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"                
                }}
                name={props.name}
                onClick={props.onChange}
            >
                <div className={props.checked ? "checkbox checked": "checkbox unchecked"}>
                    <div style={{
                        display: props.display ? props.display : "inline-block",
                        position: "relative",
                        transform: "scale(0.6, 0.6) translate(-4px, -8px)"
                    }}>
                    {
                        props.checked
                        ? <span><i className="fas fa-check"></i></span>
                        : null
                    }
                    </div>
                </div>
                {
                    props.label
                    ? <div className="checkbox-label">
                        {props.label}
                    </div>
                    : null
                }
            </div>
        </div>
    )
}

export default StyledCheckbox;
